module.exports = __webpack_public_path__ + "img/product-reviews-03.6649998d.png";